export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '5a04b38', dateTime: 1789768574226 };